import { render, staticRenderFns } from "./TechnicalTreasures.vue?vue&type=template&id=67a6667e&scoped=true&"
import script from "./TechnicalTreasures.vue?vue&type=script&lang=js&"
export * from "./TechnicalTreasures.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalTreasures.vue?vue&type=style&index=0&id=67a6667e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a6667e",
  null
  
)

export default component.exports